(() => {
  const target = (el) => (getComputedStyle(el).display === 'contents' ? el.firstElementChild : el);
  const kids = (el) => {
    const inner = el.querySelector(':scope > .group-block-content');
    return inner ? [...inner.children].map(target).filter(Boolean) : null;
  };
  const equalize = (lists) => {
    const count = Math.max(...lists.map((list) => list.length));
    for (let i = 0; i < count; i++) {
      const items = lists.map((list) => list[i]).filter(Boolean);
      const nested = items.map(kids);
      if (nested.every(Boolean)) equalize(nested);
      const max = Math.max(...items.map((el) => el.getBoundingClientRect().height));
      items.forEach((el) => {
        el.style.minHeight = `${max}px`;
        el.setAttribute('data-plist-eq', '');
      });
    }
  };
  const align = (root) => {
    const cards = [...root.querySelectorAll('product-card')].filter((card) => card.offsetParent);
    root.querySelectorAll('[data-plist-eq]').forEach((el) => {
      el.style.minHeight = '';
      el.removeAttribute('data-plist-eq');
    });
    const rows = new Map();
    cards.forEach((card) => {
      const key = Math.round(card.getBoundingClientRect().top);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(card);
    });
    rows.forEach((row) => {
      if (row.length < 2) return;
      const lists = row.map((card) => {
        const title = card.querySelector('[ref="productTitleLink"]');
        const group = title ? title.closest('.group-block-content') : null;
        return group ? [...group.children].map(target).filter(Boolean) : [];
      });
      equalize(lists);
    });
  };
  const run = () => document.querySelectorAll('[data-plist-align]').forEach(align);
  let timer;
  const later = () => {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  if (document.fonts) document.fonts.ready.then(run);
  document.addEventListener('shopify:section:load', later);
  const watch = () => {
    new MutationObserver((records) => {
      const added = records.some((record) =>
        [...record.addedNodes].some(
          (node) => node.nodeType === 1 && (node.matches('product-card') || node.querySelector('product-card'))
        )
      );
      if (added && document.querySelector('[data-plist-align]')) later();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
